import Vue from 'vue';
import '@/assets/css/UILibrary.css';
import Popup from '@/components/Common/PopUp/index';
import Toast from '@/components/Toast/toast';
import '@/components/Toast/toast.css';
import CheckInput from '@/utli/sensitiveWord'
import App from './App.vue';
import router from './router';
import '@/assets/css/reset.css';
import '@/assets/js/ydkConfig';
import '@/assets/js/zoom';
import 'video.js/dist/video-js.css';

Vue.use(CheckInput)
Vue.config.productionTip = false;
Vue.use(Toast);
Vue.use(Popup);

const vue = new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app');

export default vue;
